import { render, staticRenderFns } from "./customerMgtAdmin.vue?vue&type=template&id=64323ff0&scoped=true&"
import script from "./customerMgtAdmin.vue?vue&type=script&lang=js&"
export * from "./customerMgtAdmin.vue?vue&type=script&lang=js&"
import style0 from "./customerMgtAdmin.vue?vue&type=style&index=0&id=64323ff0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64323ff0",
  null
  
)

export default component.exports